import type { Menu } from "@/types/menu";

export const authenticatedMenu: Array<Menu> = [
  {
    label: "Dashboard",
    path: "/dashboard",
    subList: [],
  },
  {
    label: "Patients",
    path: "/patients",
    subList: [
      {
        label: "Gérer un patient",
        path: "\\/patients\\/\\d+",
      },
      {
        label: "Ajouter un patient",
        path: "\\/patients\\/fiche",
      },
    ],
  },
  {
    label: "Profil",
    path: "/profile",
    subList: [],
  },
];
